import React, { useContext, useEffect } from "react";
import { getSortedCompanies, initialCompanyFilter } from "./FilterTypes/CompanyFilterType";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import MultiPickerFilterPopup from "./MultiPickerFilterPopup";
import MultiCompanyList from "components/Picker/CompanyPicker/MultiCompanyList";

interface Props {
  title: string
}

const CompanyFilter = (props: Props) => {

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("company", {
    getTitle: () => props.title,
    renderSelection: (filter) => <>{getSortedCompanies(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedCompanies.length > 0,
    reset: () => initialCompanyFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedCompanies.map(b => b.companyId), b.selectedCompanies.map(b => b.companyId))
  });
  useEffect(() => {
    setInitialValue("company", initialCompanyFilter);
  }, []);

  const [selectedCompanies, setSelectedCompanies] = React.useState<server.dto.CompanySmall[]>(initialCompanyFilter.selectedCompanies);
  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);


  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedCompanies(getValue("company").selectedCompanies);
    setPopupOpen(true);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("company", {
      selectedCompanies
    });
    setPopupOpen(false);
  };

  return <div>
    <MultiPickerFilterPopup
      title={props.title}
      minHeight={350}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
      onApply={onApply}
    >
      <MultiCompanyList
        value={selectedCompanies}
        onChange={setSelectedCompanies}
        addressType="regular"
      />
    </MultiPickerFilterPopup>
  </div>;
};

export default CompanyFilter;
